import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/account.css";
import { useUser } from "../context/UserContext";
import AccountLayout from "../layouts/AccountLayout";
import CURRENCY from "./../assets/images/currency_icon.png";
import { adminRoles, userRankText } from "../utils";
import { useState } from "react";
import ToastNotification, { showTopCenterToast } from "../components/toasts/ToastNotification";
import { HashLoader } from "react-spinners";
import { getUser } from "../api/user.api";
import { FaCoins, FaPowerOff, FaShieldAlt, FaUserEdit } from "react-icons/fa";
import { MdAdminPanelSettings, MdPassword } from "react-icons/md";

const AccountPage = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user?._id) return;
    fetchUserData();
  }, [user?._id]);

  const fetchUserData = async () => {
    try {
      setLoading(true);

      const res = await getUser(user._id);

      if (res?.success) {
        setUser(res.data.user);
      }
    } catch (error) {
      showTopCenterToast(error.message, "error");
    }
    finally {
      setLoading(false);
    }
  }

  const handleLogout = () => {
    navigate("/logout");
  };

  const fallbackAvatar = "https://cdn1.iconfinder.com/data/icons/user-pictures/101/malecostume-512.png";
  const formattedBalance = Number(user?.balance || 0).toLocaleString("vi-VN");

  return (
    <AccountLayout title="Tài khoản của tôi">
      <div className="account-page">
        <ToastNotification />
        {loading ? (
          <div className="loader-container">
            <HashLoader color="var(--hash-loader-color)" size={30} />
          </div>
        ) : (
          <>
            <section className="account-hero-panel">
              <div className="account-hero-profile">
                <img
                  className="account-hero-avatar"
                  src={user?.profileImg || fallbackAvatar}
                  alt="User Avatar"
                />
                <div className="account-hero-meta">
                  <p className="account-hero-label">Game Profile</p>
                  <h2>{user?.username || "User"}</h2>
                  <span className="user-rank">{userRankText(user?.rank)}</span>
                </div>
              </div>

              <div className="account-hero-actions">
                <button
                  onClick={() => navigate("/account/change-information")}
                  className="account-action-btn account-action-primary"
                >
                  <FaUserEdit />
                  Cập nhật tài khoản
                </button>
                {adminRoles.includes(user?.role) && (
                  <button
                    onClick={() => navigate("/super-admin/dashboard")}
                    className="account-action-btn account-action-secondary"
                  >
                    <MdAdminPanelSettings />
                    Trang Admin
                  </button>
                )}
              </div>
            </section>

            <section className="account-stat-grid">
              <article className="account-stat-card">
                <p className="account-card-title">
                  <FaCoins />
                  Số dư hiện tại
                </p>
                <div className="user-balance-container">
                  <img className="currency" src={CURRENCY} alt="currency" />
                  <h3 className="account-user-balance">
                    {formattedBalance}đ
                  </h3>
                </div>
                <button className="account-action-btn account-action-primary" onClick={() => navigate("/payment")}>
                  Nạp tiền
                </button>
              </article>

              <article className="account-stat-card">
                <p className="account-card-title">
                  <FaShieldAlt />
                  Bảo mật tài khoản
                </p>
                <div className="account-security-mask">********</div>
                <button className="account-action-btn account-action-secondary" onClick={() => navigate("/account/change-password")}>
                  <MdPassword />
                  Đổi mật khẩu
                </button>
              </article>

              <article className="account-stat-card account-stat-card-danger">
                <p className="account-card-title">
                  <FaPowerOff />
                  Phiên đăng nhập
                </p>
                <span className="account-card-subtext">Thoát khỏi tài khoản trên thiết bị hiện tại.</span>
                <button className="account-action-btn account-action-danger" onClick={handleLogout}>
                  Đăng xuất
                </button>
              </article>
            </section>
          </>
        )}
      </div>
    </AccountLayout>
  );
};

export default AccountPage;
